import axios from 'utils/axios';

export const appointmentAttachResource = (appointmentId: string, resourceIds: Array<any>) => {
  return axios.post(`/api/v1/appointments/${appointmentId}/patientattachment`, {
    resourceIds,
    type: 'INPUT',
  });
};
